import axios from 'axios'
import { ISelectOption } from '../components/Select/Select'
import { FormModel, IRequestModel, ISignatureModel } from '../model/RequestModel'

import {protect} from "./recaptcha";

export const submitFormData = async (languageCode: string, formData: FormModel & { signature: ISignatureModel }) => {
  function getSuccessHeaderMessage() {
    return 'Uspjeh';
  }

  function getSuccessMessage() {
    return 'Obrazac uspješno predan.';
  }

  function getErrorHeaderMessage() {
    return 'Greška';
  }

  function getErrorMessage(extra: string = "") {
    return 'Nije moguće predati obrazac.' + " " + extra;
  }

  function unformatIntlNumber (val: any, locale: any) {
    let group = new Intl.NumberFormat(locale).format(1111)?.replace(/1/g, '');
    let decimal = new Intl.NumberFormat(locale).format(1.1)?.replace(/1/g, '');
    let reversedVal = val?.replace(new RegExp('\\' + group, 'g'), '');
    reversedVal = reversedVal?.replace(new RegExp('\\' + decimal, 'g'), '.');
    reversedVal = parseFloat(reversedVal);
    return reversedVal;
  }

  const toBase64 = (file:File) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

  try {
    const { signature, attachments, ...rest } = formData

    let hasPension = rest['txtHrMirovina'] === 'primamHrMirovinu';
    let dayOfBirth = rest['txtDan']?.length == 1 ? "0" + rest['txtDan'] : rest['txtDan'];
    let monthOfBirth = rest['txtMjesec']?.length == 1 ? "0" + rest['txtMjesec'] : rest['txtMjesec'];
    let iznos1NaN = unformatIntlNumber(rest['txtIznos1'], 'de-DE').toFixed(2) === "NaN"
    let iznos2NaN = unformatIntlNumber(rest['txtIznos2'], 'de-DE').toFixed(2) === "NaN"
    let iznos3NaN = unformatIntlNumber(rest['txtIznos3'], 'de-DE').toFixed(2) === "NaN"

    // TODO: hack me baby
    const data: any = rest['txtHrMirovina'] === 'nePrimamHrMirovinu' ? {
      "captcha-answer": rest['captcha-answer'],
      "captcha-token": rest['captcha-token'],
      txtIBAN: rest['txtIBAN'],
      txtIme: rest['txtIme'],
      txtPrezime: rest['txtPrezime'],
      txtOIB: rest['txtOIB'],
      txtEmail: rest['txtEmail'],
      txtInoMirovina: '',
      txtMobitel: rest['txtMobitel'],
      txtValuta1: (rest.txtValuta1 as unknown as  ISelectOption)?.value ?? "",
      txtValuta2: (rest.txtValuta2 as unknown as  ISelectOption)?.value ?? "",
      txtValuta3: (rest.txtValuta3 as unknown as  ISelectOption)?.value ?? "",
      txtIznos1: !iznos1NaN ? unformatIntlNumber(rest['txtIznos1'], 'de-DE').toFixed(2).replace('.', ',') ?? "" : "",
      txtIznos2: !iznos2NaN ? unformatIntlNumber(rest['txtIznos2'], 'de-DE').toFixed(2).replace('.', ',') ?? "" : "",
      txtIznos3: !iznos3NaN ? unformatIntlNumber(rest['txtIznos3'], 'de-DE').toFixed(2).replace('.', ',') ?? "" : "",
      'txtFormLanguage': languageCode,
      'txtData': rest['txtData']!?.toISOString().split('T')[0].split('-').reverse().join('.'),
      'txtDatumRodjenja': [dayOfBirth?.replace(".","")?.replace(",",""), monthOfBirth?.replace(".","")?.replace(",",""), rest['txtGodina']?.replace(".","")?.replace(",","") + '.'].join('.'),
      'txtOwnerBirthDate': rest['txtOwnerBirthDate']!?.toISOString().split('T')[0].split('-').reverse().join('.'),
      'txtMjesec': undefined,
      'txtDan': undefined,
      'txtGodina': undefined,
      'chkOdgovornost': undefined,
      txtDrzava1: (rest.txtDrzava1 as unknown as  ISelectOption)?.label ?? null,
      txtDrzava2: (rest.txtDrzava2 as unknown as  ISelectOption)?.label ?? null,
      txtDrzava3: (rest.txtDrzava3 as unknown as  ISelectOption)?.label ?? null,
      txtDrzavaKod1: (rest.txtDrzava1 as unknown as  ISelectOption)?.value ?? null,
      txtDrzavaKod2: (rest.txtDrzava2 as unknown as  ISelectOption)?.value ?? null,
      txtDrzavaKod3: (rest.txtDrzava3 as unknown as  ISelectOption)?.value ?? null,
    } : {
      "captcha-answer": rest['captcha-answer'],
      "captcha-token": rest['captcha-token'],
      txtIme: rest['txtIme'],
      txtPrezime: rest['txtPrezime'],
      txtOIB: rest['txtOIB'],
      txtEmail: rest['txtEmail'],
      txtInoMirovina: rest['txtInoMirovina'],
      txtMobitel: rest['txtMobitel'],
      txtValuta1: (rest.txtValuta1 as unknown as  ISelectOption)?.value ?? "",
      txtValuta2: (rest.txtValuta2 as unknown as  ISelectOption)?.value ?? "",
      txtValuta3: (rest.txtValuta3 as unknown as  ISelectOption)?.value ?? "",
      txtIznos1: !iznos1NaN ? unformatIntlNumber(rest['txtIznos1'], 'de-DE').toFixed(2) ?? "" : "",
      txtIznos2: !iznos2NaN ? unformatIntlNumber(rest['txtIznos2'], 'de-DE').toFixed(2) ?? "" : "",
      txtIznos3: !iznos3NaN ? unformatIntlNumber(rest['txtIznos3'], 'de-DE').toFixed(2) ?? "" : "",
      'txtFormLanguage': languageCode,
      'txtData': rest['txtData']!?.toISOString().split('T')[0].split('-').reverse().join('.'),
      'txtDatumRodjenja': [dayOfBirth?.replace(".","")?.replace(",",""), monthOfBirth?.replace(".","")?.replace(",",""), rest['txtGodina']?.replace(".","")?.replace(",","") + '.'].join('.'),
      'txtOwnerBirthDate': rest['txtOwnerBirthDate']!?.toISOString().split('T')[0].split('-').reverse().join('.'),
      'txtMjesec': undefined,
      'txtDan': undefined,
      'txtGodina': undefined,
      'chkOdgovornost': undefined
    }

    //let sifraObrasca = rest['txtHrMirovina'] === 'nePrimamHrMirovinu' ? 'TŽ3960' : 'TŽ'
    let endpointUrl = rest['txtHrMirovina'] === 'nePrimamHrMirovinu'
        ? window.location.origin + '/v/1/integrator/hzmo/troskovi_zivota/external'
        : window.location.origin + '/v/1/integrator/hzmo/troskovi_zivota'

    let attachmentsList = [];
    for (let i = 0; i < attachments.length; i++) {
      let fileBytes = await toBase64(attachments[i]);
      let splitData = (<string>fileBytes)?.split(";base64,");
      if (splitData?.length === 2) {
        let base64File = splitData[1];
        let extension = splitData[0]?.match(/^.+:.+\/(.+)/)?.[1];
        attachmentsList.push({"File": base64File, "FileName": attachments[i].name, "FileType": extension});
      }
    }

    if(data['txtOIB'] === '' || !data['txtOIB']){
      return {
        status: getErrorHeaderMessage(),
        message: getErrorMessage('Molimo upišite sve potrebne podatke'),
        type: "error"
      }
    }

    if(data['txtDatumRodjenja'] === '' || !rest['txtOIB']){
      return {
        status: getErrorHeaderMessage(),
        message: getErrorMessage('Molimo upišite sve potrebne podatke'),
        type: "error"
      }
    }

    const token = await protect('submit')
    //Refresh captcha
    document.getElementById("refresh-captcha-id")?.click();

    await axios.post(
        endpointUrl,
        {formData: {...data}, SignatureImage: {ImageData: signature?.data, FileType: "PNG"}, Attachments: attachmentsList},
        {headers: {'content-type': 'application/json'}},
    );
    return {
      status: getSuccessHeaderMessage(),
      message: getSuccessMessage(),
      type: "success"
    }

  } catch (error) {
    formData['captcha-answer'] = "";
    console.error(error)
    let additional = "";
    if(error?.response?.data?.errors?.[0]?.errorCode === 50000) {
      additional = "Kontrolni kod je pogrešan!";
    }

    if(error?.response?.data?.errors?.[0]?.errorCode === 50001) {
      additional = "Nije moguće kontaktirati pozadinski servis. Molimo pokušajte kasnije.";
    }
    return {
      status: getErrorHeaderMessage(),
      message: getErrorMessage(additional),
      type: "error"
    }
  }
}
